import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BellIcon from "../other-icons/BellIcon";
import "./header-notification.m.css";
function HeaderNotification() {
  const [loadIcon, setLoadIcon] = useState(false);
  const getState = useSelector((state) => state);
  const isNewNotification = get(getState, "isNewNotification");

  useEffect(() => {
    setTimeout(() => {
      setLoadIcon(true);
    }, 300);
  }, []);
  if (loadIcon) {
    return (
      <div styleName="bell-icon">
        {isNewNotification ? <div className="red-dot-notifcation"></div> : null}
        <BellIcon width="22px" height="22px" color="white" />
      </div>
    );
  }
  return null;
}

export default HeaderNotification;
